module.exports = __webpack_public_path__ + "img/line.7ced49e6.svg";